export default __webpack_public_path__ + "static/media/cross-icon.6b2fd3fd.svg";